const SVG = ({
  fill = 'none',
  fillPath = 'currentColor',
  width = '18',
  height = '19',
  viewBox = '0 0 18 19',
}) => (
  <svg
    fill={fill}
    width={width}
    height={height}
    viewBox={viewBox}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M1.237 9.06504C1.237 4.79196 4.70102 1.32794 8.9741 1.32794C13.2472 1.32794 16.7112 4.79196 16.7112 9.06504C16.7112 13.3381 13.2472 16.8021 8.9741 16.8021C4.70102 16.8021 1.237 13.3381 1.237 9.06504ZM8.9741 0.327942C4.14873 0.327942 0.237 4.23968 0.237 9.06504C0.237 13.8904 4.14873 17.8021 8.9741 17.8021C11.2084 17.8021 13.2469 16.9635 14.7918 15.5837C14.8051 15.601 14.8196 15.6177 14.8355 15.6335L17.1476 17.9457C17.3429 18.1409 17.6595 18.1409 17.8547 17.9457C18.05 17.7504 18.05 17.4338 17.8547 17.2386L15.5426 14.9264C15.5267 14.9106 15.5101 14.896 15.4928 14.8827C16.8725 13.3378 17.7112 11.2994 17.7112 9.06504C17.7112 4.23968 13.7995 0.327942 8.9741 0.327942Z"
      fill={fillPath}
    />
  </svg>
)

export default SVG


